import { createContext, useContext } from 'react';

import type { IAuthContext } from '../../interfaces/auth';

const contextDefaultValues: IAuthContext = {
  userId: '',
  email: '',
  isLoggedIn: null,
  verifyingLogin: false,
  errorCode: '',
  isBetterflyer: false,
  sessionLogin: async () => {},
  sessionLogout: async () => {},
  resetError: () => {},
  socialLogin: async () => {},
  customLogin: async () => {}
};

export const AuthContext = createContext<IAuthContext>(contextDefaultValues);

export const useAuth = () => useContext(AuthContext);
